import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface TournamentTeamsTabProps {
  data: Record<string, any>;
}

export const TournamentTeamsTab: React.FC<TournamentTeamsTabProps> = ({ data }) => {
  const teams = data.teams || [];
  const tournamentTeams = data.tournament_teams || [];

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  return (
    <div>
      <S.SectionTitle>Команды ({teams.length})</S.SectionTitle>
      {teams.length === 0 ? (
        <S.EmptyState>Нет данных о командах</S.EmptyState>
      ) : (
        teams.map((team: any, index: number) => (
          <S.ListItem key={index}>
            <S.ListItemTitle>{team.team_name || 'Без названия'}</S.ListItemTitle>
            <S.InfoRow>
              <S.InfoLabel>ID команды</S.InfoLabel>
              <S.InfoValue>{team.team_id || '—'}</S.InfoValue>
            </S.InfoRow>
            <S.InfoRow>
              <S.InfoLabel>Капитан</S.InfoLabel>
              <S.InfoValue>
                <S.Badge $variant={team.is_captain ? 'success' : undefined}>
                  {team.is_captain ? 'Да' : 'Нет'}
                </S.Badge>
              </S.InfoValue>
            </S.InfoRow>
            <S.InfoRow>
              <S.InfoLabel>Позиция</S.InfoLabel>
              <S.InfoValue>{team.position !== undefined ? team.position : '—'}</S.InfoValue>
            </S.InfoRow>
            <S.InfoRow>
              <S.InfoLabel>Huddle Server ID</S.InfoLabel>
              <S.InfoValue>{team.huddle_server_id || '—'}</S.InfoValue>
            </S.InfoRow>
            <S.InfoRow>
              <S.InfoLabel>Присоединился</S.InfoLabel>
              <S.InfoValue>{formatDate(team.joined_at)}</S.InfoValue>
            </S.InfoRow>
            <S.InfoRow>
              <S.InfoLabel>Создана</S.InfoLabel>
              <S.InfoValue>{formatDate(team.team_created_at)}</S.InfoValue>
            </S.InfoRow>
          </S.ListItem>
        ))
      )}

      {tournamentTeams.length > 0 && (
        <>
          <S.SectionTitle>Команды в турнирах ({tournamentTeams.length})</S.SectionTitle>
          {tournamentTeams.map((tt: any, index: number) => (
            <S.ListItem key={index}>
              <S.ListItemTitle>{tt.tournament_name || 'Турнир'}</S.ListItemTitle>
              <S.InfoRow>
                <S.InfoLabel>Команда</S.InfoLabel>
                <S.InfoValue>{tt.team_name || '—'}</S.InfoValue>
              </S.InfoRow>
              <S.InfoRow>
                <S.InfoLabel>Посев</S.InfoLabel>
                <S.InfoValue>{tt.seed || '—'}</S.InfoValue>
              </S.InfoRow>
              <S.InfoRow>
                <S.InfoLabel>Создана</S.InfoLabel>
                <S.InfoValue>{formatDate(tt.team_created_at)}</S.InfoValue>
              </S.InfoRow>
            </S.ListItem>
          ))}
        </>
      )}
    </div>
  );
};

